import {useNavigate} from "react-router-dom";
import filesService from "../../services/files.service";
import {CategoriesChipColors, ProjectInfo} from "../../models/ProjectForm";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Chip, IconButton, Typography} from "@material-tailwind/react";
import {faEnvelope, faUser, faDownload, faMaximize, faUpRightFromSquare, faUserGroup} from '@fortawesome/free-solid-svg-icons';
import {faClone} from '@fortawesome/free-regular-svg-icons';
import {colors} from "@material-tailwind/react/types/generic";
import './ProjectCard.css';

interface ProjectInfoProps {
    project: ProjectInfo,
}

const ProjectCard = ({project}: ProjectInfoProps) => {
    const navigate = useNavigate();

    const handleCardClick = () => {
        navigate(`/admin/forms/projects/${project.uuid}`);
    }

    const handleDownload = async () => {
        const response = await filesService.getFile(project.locationFile);
        if (response.status === 200) {
            filesService.processFileToDownload(response, `ProjectFile_${project.projectName}.pdf`);
        }
    }

    const handleOpenFileEmergent = async () => {
        filesService.openFileOnEmergentWindow(project.locationFile);
    }

    const getCihpColor = (value: string): colors => {
        return CategoriesChipColors[value] || 'black';
    }

    return (
        <div className="card">
            <div className="info-project">
                <Typography variant="h4" color="black" placeholder=''>{project.projectName}</Typography>
                <div className="flex justify-between">
                    <span className="flex gap-2">
                        <Chip value={project.category} size="sm" color={getCihpColor(project.category)}/>
                        <Chip value={project.subject} size="sm" color="amber"/>
                    </span>
                    <Chip value={project.members.length } icon={<FontAwesomeIcon icon={faUserGroup} />} size="sm" />
                </div>
            </div>
            <div className="card-footer">
                <div className='info-member'>
                    <p><FontAwesomeIcon icon={faUser} color='#feb310'/> {project.members[0].name}</p>
                    <div>
                        <FontAwesomeIcon icon={faEnvelope} color='#feb310'/>
                        {project.members[0].email}
                        <FontAwesomeIcon
                            className='info-email-clone'
                            onClick={() => {
                                navigator.clipboard.writeText(project.members[0].email)
                            }}
                            icon={faClone}
                            color='gray'/>
                    </div>
                </div>
                <div className="btn-container">
                    <IconButton variant='text' placeholder='' onClick={handleDownload}>
                        <FontAwesomeIcon icon={faDownload} color='#03A300' size="lg"/>
                    </IconButton>
                    <IconButton variant='text' placeholder='' onClick={handleOpenFileEmergent}>
                        <FontAwesomeIcon icon={faUpRightFromSquare} color='#03A300' size="lg"/>
                    </IconButton>
                    <IconButton variant='text' placeholder='' onClick={handleCardClick}>
                        <FontAwesomeIcon icon={faMaximize} color='#757575' size="lg"/>
                    </IconButton>
                </div>
            </div>
        </div>
    )
}

export default ProjectCard